import {AfterContentInit, Component, Input} from '@angular/core';

/**
 * Component to handle displaying of the users name
 * Defaults to first last and then username if those aren't present
 * @class
 * @implements {AfterContentInit}
 */
@Component({
  selector: 'advtech-user-name',
  templateUrl: './user-name.component.html',
})
export class UserNameComponent implements AfterContentInit {
  /**
   * attribute to pass in the author object
   * @type {any}
   */
  @Input()
  user: any;

  /**
   * the users name we will display
   * @type {string}
   */
  name: string;

  /** @inheritdoc */
  ngAfterContentInit() {
    const user = this.user && this.user[0] ? this.user[0] : this.user;
    let name = '';

    if (user) {
      if (user.cmsDisplayName) {
        name = user.cmsDisplayName;
      }
      else if (user.username) {
        name = user.username;
      }
    }

    this.name = name;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/user-name/user-name.component.ts